import { Component, OnInit, HostListener } from '@angular/core';
import { LanguageService } from '@app/core/services';

/** PSIRT - 安全漏洞回報頁面 */
@Component({
    selector: 'app-psirt',
    templateUrl: './psirt.component.html',
    styleUrls: ['./psirt.component.scss'],
})
export class PsirtComponent implements OnInit {
    isSmallScreen: boolean = false;

    constructor(private languageService: LanguageService) {}

    ngOnInit() {
        this.checkScreenSize();
    }

    @HostListener('window:resize')
    onResize() {
        this.checkScreenSize();
    }

    /**
     * 檢查螢幕尺寸
     */
    checkScreenSize() {
        this.isSmallScreen = window.innerWidth <= 390;
    }

    /**
     * 當前語系是否為英文
     */
    isEnglish(): boolean {
        return this.languageService.getCurrentLang() === 'en-us';
    }

    /**
     * 取得標題的翻譯 key
     */
    getTitleKey(): string {
        if (this.isEnglish() && this.isSmallScreen) {
            return 'psirt.titleSmall';
        }
        return 'psirt.title';
    }
}
